var path = 'app/scripts/modules/core/src/bootstrap/spinnakerHeader.html';
var html = "<spinnaker-header></spinnaker-header>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/bootstrap/spinnakerHeader.html
// module id = 938
// module chunks = 0